import React, { useEffect, createElement } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { OfferBanner } from './components/OfferBanner';
import { HeroSection } from './components/HeroSection';
import { ExampleBlock } from './components/ExampleBlock';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { HowItWorks } from './components/HowItWorks';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { ProofSection } from './components/ProofSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { BonusSection } from './components/BonusSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
import { ResultsSection } from './components/ResultsSection';
import { MidPageCTA } from './components/MidPageCTA';
import { TrustSection } from './components/TrustSection';
export function App() {
  useEffect(() => {
    document.title = 'Herramientas para padres separados';
    // Set Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Herramientas para padres separados');
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-navy font-sans text-slate-100 selection:bg-red-200 selection:text-red-900 pt-16 sm:pt-12" data-id="element-0">
      <OfferBanner data-id="element-1" />
      <SocialProofNotification data-id="element-2" />

      {/* 1. Hook (Impacto inicial) */}
      <HeroSection data-id="element-3" />
      <OpeningHook data-id="element-4" />

      {/* 2. Problema */}
      <ProblemSection data-id="element-5" />
      <FailedAttempts data-id="element-6" />
      <ExampleBlock data-id="element-7" />
      <MidPageCTA data-id="element-8" />

      {/* 3. Identificación emocional */}
      <WhoIsThisFor data-id="element-9" />

      {/* 4. Solución */}
      <UniqueMethod data-id="element-10" />
      <HowItWorks data-id="element-11" />

      {/* 5. Beneficios */}
      <WhatYouGet data-id="element-12" />
      <BonusSection data-id="element-13" />
      <ResultsSection data-id="element-14" />
      <MidPageCTA data-id="element-15" />

      {/* 6. Prueba / credibilidad */}
      <ProofSection data-id="element-16" />
      <Testimonials data-id="element-17" />

      {/* 7. CTA Final */}
      <OfferBlock data-id="element-18" />
      <FAQSection data-id="element-19" />
      <TrustSection data-id="element-20" />
      <Footer data-id="element-21" />
    </div>;
}